import { Period } from "./types";
import { AppTranslations } from "../../../../../components/Utils/translations/AppTranslations";

export const getPeriodLabel = (
	period: Period,
	appTranslation: AppTranslations,
) => {
	const translation = appTranslation.massiveActions.censusCooler;
	switch (period) {
		case Period.yearToDate:
			return translation.yearToDate;
		case Period.last12month:
			return translation.last12Months;
		case Period.customDate:
			return translation.customDate;
	}
};

export const createSelectOption = (period: Period, appTranslations) => {
	return {
		value: period,
		label: getPeriodLabel(period, appTranslations),
	};
};

export const createSelectOptions = (appTranslations) => {
	return Object.values(Period).map((period) =>
		createSelectOption(period, appTranslations),
	);
};

export const formatDateYYYYmmDD = (date: Date | string) => {
	let d = new Date(date),
		month = "" + (d.getMonth() + 1),
		day = "" + d.getDate(),
		year = d.getFullYear();

	if (month.length < 2) month = "0" + month;
	if (day.length < 2) day = "0" + day;

	return [year, month, day].join("-");
};
